import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
const getNewsEventsData = createSelector(getState, (state) => state.newsEventsArticles);
export const getNewsEventsArticles = createSelector(getNewsEventsData, (state) => state.newsEvents);
export const getNewsEventsArticlesLoadingStatus = createSelector(getNewsEventsData, (state) => state.isLoading);
export const getNewsEventsArticlesLoadedStatus = createSelector(getNewsEventsData, (state) => state.isLoaded);
